import React, { useState } from 'react';
import InputButton from '../../../Shared/FormComponents/InputButton';
import InputText from '../../../Shared/FormComponents/InputText';
import { updateDirectDebit, validateDirectDebit } from '../../../../lib/api/directdebit';
import Form from '../../../Shared/Form';
import * as Yup from 'yup';
import { ReactComponent as ArrowDownIcon } from '../../../Shared/svgs/arrow-triangle-down-magenta.svg';
import { ReactComponent as ArrowRightIcon } from '../../../Shared/svgs/arrow-triangle-right-magenta.svg';

const ModalBackground = () => {
    return <div id="ModalBackground" className='bg-everflow-black' style={{ position: 'fixed', zIndex: 25, top: 0, left: 0, width: '1000vw', height: '1000vh', opacity: '0.5' }}></div>
};

const ConfirmModal = ({ accountNumber, sortCode, accountHolder, updateDirectDebitDetails, setShowConfirmModal, setSubmitting, submitting }) => {
    if (!accountNumber || !sortCode) {
        return null
    }

    const text = 'By submitting you agree you are authorised to make changes and you have read our Direct Debit Guarantee.';

    return (
        <>
            <ModalBackground></ModalBackground>
            <div className='modal'>
                <p className='mb-4 text-everflow-black'>{text}</p>
                <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
                    <button id="DDConfirmModalCancelButton" className='button pink faux' disabled={submitting === "submitting"} onClick={() => { setSubmitting(); setShowConfirmModal(false); }}>Cancel</button>
                    <button
                        id="DDConfirmModalConfirmButton"
                        className='button pink'
                        disabled={submitting === "submitting"}
                        onClick={() => { setSubmitting("submitting"); updateDirectDebitDetails({ accountNumber, sortCode, accountHolder }); }}
                    >Confirm</button>
                </div>
            </div>
        </>
    )
};

const DirectDebitDetails = ({ customerAccountNumber, billingEmail }) => {

    const [loading, setLoading] = useState();
    const [success, setSuccess] = useState();
    const [statusMessage, setStatusMessage] = useState(false);
    const [errorStatus, setErrorStatus] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [isGuaranteeOpen, setIsGuaranteeOpen] = useState(true);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const validateDirectDebitDetails = ({ accountNumber, sortCode, accountHolder }, { setStatus, setErrors }) => {
        setLoading(true);
        validateDirectDebit(accountNumber.trim(), sortCode.trim())
            .then(resp => {
                setLoading(false);
                if (resp.data.isSuccess) {
                    if (resp.data.data) {
                        setShowConfirmModal(true);
                        setErrorStatus(false);
                    } else {
                        setErrorStatus(true);
                        setStatusMessage("Invalid bank details");
                    }
                } else {
                    setSuccess(false);
                    setErrorStatus(true);
                    setStatusMessage("Unfortunately, an error occurred validating the details");
                }
            })
            .catch(err => {
                setLoading(false);
                setSuccess(false);
                setErrorStatus(true);
                setStatusMessage("Unfortunately, an error occurred validating the details");
            });
    };

    const updateDirectDebitDetails = ({ accountNumber, sortCode, accountHolder}) => {
        setLoading(true);
        updateDirectDebit(customerAccountNumber, accountNumber, sortCode, accountHolder, billingEmail)
            .then(resp => {
                setLoading(false);
                setSubmitting(false);
                if (resp.data.isSuccess) {
                    setSuccess(true);
                    setErrorStatus(false);
                    setShowConfirmModal(false);
                    setStatusMessage("Your Direct Debit details have been submitted for approval. It can take up to 10 working days for a new Direct Debit to be approved. An email notification will be sent to confirm Direct Debit approval.");
                } else {
                    setSuccess(false);
                    setErrorStatus(true);
                    setStatusMessage("Unfortunately, an error occurred submitting the details");
                }
            })
            .catch(err => {
                setLoading(false);
                setSuccess(false);
                setErrorStatus(true);
                setStatusMessage("Unfortunately, an error occurred submitting the details");
                setSubmitting(false);
            });
    };

    const toggleDropdown = () => {
        setIsGuaranteeOpen(prevState => !prevState);
    };

    const restrictToNumericEntry = (evt) => {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }

        return true;
    };

    return (
        <div className="generic-details__block your-details__direct-debit">
            <h3 className="uppercase text-18px sm:text-16px text-everflow-magenta font-bold text-center">Manage your direct debit</h3>
            <p className="mt-32px text-everflow-black">
                Please fill in the form below to request a change to your Direct Debit details. If you update details within 10 days of next payment the changes won&apos;t apply
            </p>

            {success ? (
                <div className="mt-32px">
                    <p className="text-everflow-black">{statusMessage}</p>
                </div>
            ) : (
            <div className="direct-debit-details">

                <Form
                    initialValues={{ accountNumber: '', sortCode: '', accountHolder: '' }}
                    validationSchema={directDebitSchema}
                    onSubmit={validateDirectDebitDetails}
                    className="your-details__dd-form"
                >
                    {({ values, handleChange, setFieldValue, errors, touched, handleBlur, handleSubmit }) => {
                                return (
                            <>
                            {showConfirmModal &&
                                            <ConfirmModal
                                                accountNumber={values.accountNumber}
                                                sortCode={values.sortCode}
                                                accountHolder={values.accountHolder}
                                                updateDirectDebitDetails={updateDirectDebitDetails}
                                                setShowConfirmModal={setShowConfirmModal}
                                                setSubmitting={setSubmitting}
                                                submitting={submitting}>
                                            </ConfirmModal>}

                                                <div className="your-details__dd-row">
                                                    <div className="your-details__dd-field">
                                                        <InputText
                                                            label="Account no."
                                                            placeholder=""
                                                            id="accountNumber"
                                                            required
                                                            maxLength="8"
                                                            value={values.accountNumber}
                                                            error={errors.accountNumber}
                                                            onChange={e => setFieldValue('accountNumber', e.target.value.trim())}
                                                            onBlur={handleBlur}
                                                            onKeyPress={restrictToNumericEntry}
                                                        />
                                                    </div>
                                                    <div className="your-details__dd-field">
                                                        <InputText
                                                            label="Sort code"
                                                            placeholder=""
                                                            id="sortCode"
                                                            required
                                                            maxLength="6"
                                                            value={values.sortCode}
                                                            error={errors.sortCode}
                                                            onChange={(e) => setFieldValue('sortCode', e.target.value.trim())}
                                                            onBlur={handleBlur}
                                                            onKeyPress={restrictToNumericEntry}
                                                        />
                                                    </div>
                                                    <div className="your-details__dd-field">
                                                        <InputText
                                                            label="Account holder"
                                                            placeholder=""
                                                            id="accountHolder"
                                                            required
                                                            value={values.accountHolder}
                                                            error={errors.accountHolder}
                                                            onChange={(e) => setFieldValue('accountHolder', e.target.value)}
                                                            onBlur={handleBlur}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="your-details__dd-footer">
                                                    <InputButton
                                                        id="update-direct-debit-details-button"
                                                        loading={loading}
                                                        className="font-bold"
                                                        label="Submit"
                                                        fitWidth={true}
                                                        onClick={handleSubmit}
                                                    />
                                                </div>

                                        <div className="your-details__dd-error">
                                            {errorStatus ? (<div className="mt-1px">
                                                <p className="text-everflow-red">{statusMessage}</p>
                                            </div>) : ''}
                                        </div>
                            </>
                        )
                    }}

                </Form>

                <div className="direct-debit-guarantee mt-4">
                    <div className="dd-guarantee-header" onClick={toggleDropdown}>
                        <h3>Direct Debit guarantee</h3>
                        {isGuaranteeOpen ? (
                            <ArrowDownIcon className="arrow-icon" />
                        ) : (
                            <ArrowRightIcon className="arrow-icon" />
                        )}
                    </div>
                    {isGuaranteeOpen && (
                        <div>
                            <p className="dd-text mb-2 mt-2">
                                This guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.
                            </p>
                            <p className="dd-text mb-2">
                                If there are any changes to the amount, date, or frequency of your Direct Debit,Everflow will notify you
                                (usually 10 working days in advance) of your account being debited or otherwise agreed.
                            </p>
                            <p className="dd-text mb-2">
                                If you request Everflow to collect a payment, confirmation of the amount and date will be given to you at the time of the request.
                            </p>
                            <p className="dd-text mb-2">
                                If an error is made in the payment of your Direct Debit, by Everflow or your bank or building society, you are entitled to a full
                                and immediate refund of the amount paid from your bank or building society.
                            </p>
                            <p className="dd-text mb-2">
                                If you receive a refund you are not entitled to, you must pay it back when Everflow asks you to.
                            </p>
                            <p className="dd-text">
                                You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us.
                            </p>
                        </div>
                    )}
                </div>
                </div>
                )}
            </div>
    )
}

const directDebitSchema = Yup.object().shape({
    accountNumber: Yup.string().min(8).max(8).matches(/^[0-9]+$/, 'Account Number must only contain numbers').required('Please enter your bank account number').label("Account Number"),
    sortCode: Yup.string().min(6).max(6).matches(/^[0-9]+$/, 'Sort Code must only contain numbers').required('Please enter your bank sort code').label("Sort Code"),
    accountHolder: Yup.string().required('Please enter the bank account holder')
})

export default DirectDebitDetails;
